import React, { createContext, useContext, useState, useCallback } from "react";

const ToastCtx = createContext({ push: ()=>{} });

export function ToastProvider({ children }){
  const [items, setItems] = useState([]);
  const push = useCallback((msg, type="success", ttl=3000)=>{
    const id = Math.random().toString(36).slice(2);
    setItems(arr => [...arr, { id, msg, type }]);
    setTimeout(()=> setItems(arr => arr.filter(x => x.id !== id)), ttl);
  },[]);
  return (
    <ToastCtx.Provider value={{ push }}>
      <div className="toast">
        {items.map(t => (
          <div key={t.id} className={`toast-item ${t.type==='error'?'toast-error':'toast-success'}`}>
            {t.msg}
          </div>
        ))}
      </div>
      {children}
    </ToastCtx.Provider>
  );
}

export function useToasts(){ return useContext(ToastCtx); }
